<template>
    <div class="play-report">
        <i class="fas fa-play"></i>
        <i class="fas fa-file-alt system-text-color system-text-shadow"></i>
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.play-report {
    position: relative;

    .fa-play {
        font-size: 12px;
        position: absolute;
        top: 50%;
        left: -5px;
        transform: translateY(-50%);
        text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.6);
    }
}
</style>
